const p = (english, mandarin, spoken) => ({ english, mandarin, spoken });
const group = (id, title, phrases) => ({ id, title, phrases });

export const highFrequencyVocabSets = [
  {
    id: 'hf-verbs',
    title: '100 High-Frequency Verbs',
    groups: [
      group('hf-verbs', 'Verbs', [
        p('be', 'shì', '是'),
        p('have', 'yǒu', '有'),
        p('do', 'zuò', '做'),
        p('say', 'shuō', '说'),
        p('go', 'qù', '去'),
        p('get', 'dédào', '得到'),
        p('make', 'zuò', '做'),
        p('know', 'zhīdào', '知道'),
        p('think', 'xiǎng', '想'),
        p('take', 'ná', '拿'),
        p('see', 'kàn', '看'),
        p('come', 'lái', '来'),
        p('want', 'xiǎng yào', '想要'),
        p('use', 'yòng', '用'),
        p('find', 'zhǎo', '找'),
        p('give', 'gěi', '给'),
        p('tell', 'gàosu', '告诉'),
        p('work', 'gōngzuò', '工作'),
        p('call', 'dǎ diànhuà', '打电话'),
        p('try', 'shì', '试'),
        p('move', 'yídòng', '移动'),
        p('turn', 'zhuǎn', '转'),
        p('open', 'dǎkāi', '打开'),
        p('close', 'guān', '关'),
        p('walk', 'zǒu', '走'),
        p('run', 'pǎo', '跑'),
        p('bring', 'dài lái', '带来'),
        p('carry', 'ná', '拿'),
        p('hold', 'ná zhe', '拿着'),
        p('put', 'fàng', '放'),
        p('keep', 'bǎochí', '保持'),
        p('leave', 'líkāi', '离开'),
        p('follow', 'gēn', '跟'),
        p('stop', 'tíng', '停'),
        p('start', 'kāishǐ', '开始'),
        p('sit', 'zuò', '坐'),
        p('stand', 'zhàn', '站'),
        p('reach', 'dàodá', '到达'),
        p('pass', 'jīngguò', '经过'),
        p('push', 'tuī', '推'),
        p('ask', 'wèn', '问'),
        p('answer', 'huídá', '回答'),
        p('explain', 'jiěshì', '解释'),
        p('show', 'gěi… kàn', '给看'),
        p('speak', 'shuō', '说'),
        p('talk', 'tán', '谈'),
        p('listen', 'tīng', '听'),
        p('hear', 'tīngjiàn', '听见'),
        p('read', 'dú', '读'),
        p('write', 'xiě', '写'),
        p('understand', 'dǒng', '懂'),
        p('remember', 'jìde', '记得'),
        p('forget', 'wàngjì', '忘记'),
        p('believe', 'xiāngxìn', '相信'),
        p('feel', 'gǎndào', '感到'),
        p('like', 'xǐhuan', '喜欢'),
        p('dislike', 'bù xǐhuan', '不喜欢'),
        p('agree', 'tóngyì', '同意'),
        p('disagree', 'bù tóngyì', '不同意'),
        p('decide', 'juédìng', '决定'),
        p('eat', 'chī', '吃'),
        p('drink', 'hē', '喝'),
        p('sleep', 'shuìjiào', '睡觉'),
        p('cook', 'zuòfàn', '做饭'),
        p('clean', 'dǎsǎo', '打扫'),
        p('wash', 'xǐ', '洗'),
        p('buy', 'mǎi', '买'),
        p('pay', 'fù qián', '付钱'),
        p('sell', 'mài', '卖'),
        p('help', 'bāngzhù', '帮助'),
        p('check', 'jiǎnchá', '检查'),
        p('change', 'gǎibiàn', '改变'),
        p('choose', 'xuǎnzé', '选择'),
        p('wait', 'děng', '等'),
        p('need', 'xūyào', '需要'),
        p('fill', 'tiánmǎn', '填满'),
        p('break', 'dǎpò', '打破'),
        p('build', 'jiànzào', '建造'),
        p('cut', 'qiē', '切'),
        p('meet', 'jiànmiàn', '见面'),
        p('guide', 'yǐndǎo', '引导'),
        p('point', 'zhǐ', '指'),
        p('invite', 'yāoqǐng', '邀请'),
        p('join', 'jiārù', '加入'),
        p('return', 'huílái', '回来'),
        p('stay', 'dāi', '待'),
        p('begin', 'kāishǐ', '开始'),
        p('finish', 'wánchéng', '完成'),
        p('continue', 'jìxù', '继续'),
        p('repeat', 'chóngfù', '重复'),
        p('improve', 'gǎijìn', '改进'),
        p('practice', 'liànxí', '练习'),
        p('plan', 'jìhuà', '计划'),
        p('prepare', 'zhǔnbèi', '准备'),
        p('learn', 'xuéxí', '学习'),
      ]),
    ],
  },
  {
    id: 'hf-nouns',
    title: '120 High-Frequency Nouns',
    groups: [
      group('people-roles', 'People & Roles', [
        p('person', 'rén', '人'),
        p('man', 'nánrén', '男人'),
        p('woman', 'nǚrén', '女人'),
        p('child', 'háizi', '孩子'),
        p('friend', 'péngyou', '朋友'),
        p('family', 'jiārén', '家人'),
        p('neighbor', 'línjū', '邻居'),
        p('customer', 'gùkè', '顾客'),
        p('worker', 'gōngrén', '工人'),
        p('manager', 'jīnglǐ', '经理'),
        p('teacher', 'lǎoshī', '老师'),
        p('student', 'xuésheng', '学生'),
        p('doctor', 'yīshēng', '医生'),
        p('driver', 'sījī', '司机'),
        p('guest', 'kèrén', '客人'),
      ]),
      group('body-health', 'Body & Health', [
        p('head', 'tóu', '头'),
        p('hand', 'shǒu', '手'),
        p('face', 'liǎn', '脸'),
        p('eye', 'yǎnjing', '眼睛'),
        p('voice', 'shēngyīn', '声音'),
        p('health', 'jiànkāng', '健康'),
        p('pain', 'téngtòng', '疼痛'),
        p('medicine', 'yào', '药'),
        p('hospital', 'yīyuàn', '医院'),
        p('clinic', 'zhěnsuǒ', '诊所'),
      ]),
      group('daily-objects', 'Daily Objects', [
        p('phone', 'shǒujī', '手机'),
        p('bag', 'bāo', '包'),
        p('wallet', 'qiánbāo', '钱包'),
        p('key', 'yàoshi', '钥匙'),
        p('card', 'kǎ', '卡'),
        p('ticket', 'piào', '票'),
        p('receipt', 'shōujù', '收据'),
        p('bottle', 'píngzi', '瓶子'),
        p('cup', 'bēizi', '杯子'),
        p('plate', 'pánzi', '盘子'),
        p('spoon', 'sháozi', '勺子'),
        p('fork', 'chāzi', '叉子'),
        p('knife', 'dāozi', '刀子'),
        p('chair', 'yǐzi', '椅子'),
        p('table', 'zhuōzi', '桌子'),
      ]),
      group('home-living', 'Home & Living', [
        p('room', 'fángjiān', '房间'),
        p('house', 'fángzi', '房子'),
        p('apartment', 'gōngyù', '公寓'),
        p('kitchen', 'chúfáng', '厨房'),
        p('bathroom', 'yùshì', '浴室'),
        p('bed', 'chuáng', '床'),
        p('door', 'mén', '门'),
        p('window', 'chuānghu', '窗户'),
        p('light', 'dēng', '灯'),
        p('water', 'shuǐ', '水'),
        p('electricity', 'diàn', '电'),
        p('internet', 'hùliánwǎng', '互联网'),
      ]),
      group('food-drink', 'Food & Drink', [
        p('food', 'shíwù', '食物'),
        p('drink', 'yǐnliào', '饮料'),
        p('bread', 'miànbāo', '面包'),
        p('fruit', 'shuǐguǒ', '水果'),
        p('vegetable', 'shūcài', '蔬菜'),
        p('meat', 'ròu', '肉'),
        p('rice', 'mǐfàn', '米饭'),
        p('coffee', 'kāfēi', '咖啡'),
        p('tea', 'chá', '茶'),
        p('juice', 'guǒzhī', '果汁'),
        p('snack', 'língshí', '零食'),
        p('meal', 'cān', '餐'),
      ]),
      group('places', 'Places', [
        p('store', 'shāngdiàn', '商店'),
        p('shop', 'diàn', '店'),
        p('market', 'shìchǎng', '市场'),
        p('restaurant', 'cāntīng', '餐厅'),
        p('hotel', 'jiǔdiàn', '酒店'),
        p('airport', 'jīchǎng', '机场'),
        p('station', 'chēzhàn', '车站'),
        p('office', 'bàngōngshì', '办公室'),
        p('school', 'xuéxiào', '学校'),
        p('street', 'jiēdào', '街道'),
        p('road', 'lù', '路'),
        p('corner', 'guǎijiǎo', '拐角'),
        p('entrance', 'rùkǒu', '入口'),
        p('exit', 'chūkǒu', '出口'),
      ]),
      group('transportation', 'Transportation', [
        p('car', 'qìchē', '汽车'),
        p('bus', 'gōngjiāo chē', '公交车'),
        p('train', 'huǒchē', '火车'),
        p('taxi', 'chūzūchē', '出租车'),
        p('bike', 'zìxíngchē', '自行车'),
        p('plane', 'fēijī', '飞机'),
        p('ticket (transport)', 'piào', '票'),
        p('seat', 'zuòwèi', '座位'),
        p('bag (luggage)', 'bāo', '包'),
        p('luggage', 'xíngli', '行李'),
      ]),
      group('time-scheduling', 'Time & Scheduling', [
        p('day', 'tiān', '天'),
        p('week', 'xīngqī', '星期'),
        p('month', 'yuè', '月'),
        p('year', 'nián', '年'),
        p('morning', 'zǎoshang', '早上'),
        p('afternoon', 'xiàwǔ', '下午'),
        p('evening', 'wǎnshang', '晚上'),
        p('night', 'yèwǎn', '夜晚'),
        p('hour', 'xiǎoshí', '小时'),
        p('minute', 'fēnzhōng', '分钟'),
      ]),
      group('work-tasks', 'Work & Tasks', [
        p('job', 'gōngzuò', '工作'),
        p('work (noun)', 'gōngzuò', '工作'),
        p('task', 'rènwù', '任务'),
        p('project', 'xiàngmù', '项目'),
        p('meeting', 'huìyì', '会议'),
        p('plan (noun)', 'jìhuà', '计划'),
        p('idea', 'zhǔyì', '主意'),
        p('problem', 'wèntí', '问题'),
        p('solution', 'jiějué bànfǎ', '解决办法'),
        p('question', 'wèntí', '问题'),
      ]),
      group('technology', 'Technology', [
        p('computer', 'diànnǎo', '电脑'),
        p('laptop', 'bǐjìběn diànnǎo', '笔记本电脑'),
        p('charger', 'chōngdiànqì', '充电器'),
        p('screen', 'píngmù', '屏幕'),
        p('app', 'yīngyòng', '应用'),
        p('message', 'xiāoxi', '消息'),
        p('call (noun)', 'diànhuà', '电话'),
      ]),
      group('general-concepts', 'General Concepts', [
        p('thing', 'dōngxi', '东西'),
        p('place', 'dìfang', '地方'),
        p('reason', 'yuányīn', '原因'),
        p('way', 'fāngfǎ', '方法'),
        p('help (noun)', 'bāngzhù', '帮助'),
      ]),
    ],
  },
  {
    id: 'hf-adjectives',
    title: '100 High-Frequency Adjectives',
    groups: [
      group('basic-descriptions', 'Basic Descriptions', [
        p('good', 'hǎo', '好'),
        p('bad', 'huài', '坏'),
        p('big', 'dà', '大'),
        p('small', 'xiǎo', '小'),
        p('long', 'cháng', '长'),
        p('short', 'duǎn', '短'),
        p('tall', 'gāo', '高'),
        p('low', 'dī', '低'),
        p('high', 'gāo', '高'),
        p('large', 'dà', '大'),
      ]),
      group('quality-condition', 'Quality & Condition', [
        p('new', 'xīn', '新'),
        p('old', 'jiù', '旧'),
        p('clean', 'gānjìng', '干净'),
        p('dirty', 'zāng', '脏'),
        p('open (adj)', 'kāi zhe', '开着'),
        p('closed', 'guān zhe', '关着'),
        p('safe', 'ānquán', '安全'),
        p('dangerous', 'wēixiǎn', '危险'),
        p('easy', 'róngyì', '容易'),
        p('difficult', 'kùnnán', '困难'),
      ]),
      group('feelings-adj', 'Feelings', [
        p('happy', 'gāoxìng', '高兴'),
        p('sad', 'nánguò', '难过'),
        p('tired', 'lèi', '累'),
        p('hungry', 'è', '饿'),
        p('thirsty', 'kě', '渴'),
        p('angry', 'shēngqì', '生气'),
        p('excited', 'xīngfèn', '兴奋'),
        p('bored', 'wúliáo', '无聊'),
        p('stressed', 'yālì dà', '压力大'),
        p('calm', 'píngjìng', '平静'),
      ]),
      group('appearance', 'Appearance', [
        p('beautiful', 'měilì', '美丽'),
        p('pretty', 'piàoliang', '漂亮'),
        p('ugly', 'chǒu', '丑'),
        p('simple', 'jiǎndān', '简单'),
        p('modern', 'xiàndài', '现代'),
        p('traditional', 'chuántǒng', '传统'),
        p('bright', 'liàng', '亮'),
        p('dark', 'àn', '暗'),
        p('colorful', 'duōcǎi', '多彩'),
        p('plain', 'pǔtōng', '普通'),
      ]),
      group('taste-food', 'Taste & Food', [
        p('delicious', 'hǎochī', '好吃'),
        p('spicy', 'là', '辣'),
        p('sweet', 'tián', '甜'),
        p('salty', 'xián', '咸'),
        p('bitter', 'kǔ', '苦'),
        p('fresh', 'xīnxiān', '新鲜'),
        p('hot', 'rè', '热'),
        p('cold', 'lěng', '冷'),
        p('warm', 'nuǎnhuo', '暖和'),
        p('raw', 'shēng', '生'),
      ]),
      group('size-amount', 'Size & Amount', [
        p('full', 'mǎn', '满'),
        p('empty', 'kōng', '空'),
        p('heavy', 'zhòng', '重'),
        p('light (weight)', 'qīng', '轻'),
        p('enough', 'gòu', '够'),
        p('extra', 'éwài', '额外'),
        p('few', 'shǎo', '少'),
        p('many', 'duō', '多'),
        p('several', 'jǐ ge', '几个'),
        p('whole', 'zhěngge', '整个'),
      ]),
      group('speed-time', 'Speed & Time', [
        p('fast', 'kuài', '快'),
        p('slow', 'màn', '慢'),
        p('early', 'zǎo', '早'),
        p('late', 'wǎn', '晚'),
        p('quick', 'kuài', '快'),
        p('sudden', 'túrán', '突然'),
        p('recent', 'zuìjìn', '最近'),
        p('past', 'guòqù', '过去'),
        p('future', 'wèilái', '未来'),
        p('daily', 'měitiān', '每天'),
      ]),
      group('usefulness', 'Usefulness', [
        p('important', 'zhòngyào', '重要'),
        p('useful', 'yǒuyòng', '有用'),
        p('necessary', 'bìyào', '必要'),
        p('possible', 'kěnéng', '可能'),
        p('impossible', 'bù kěnéng', '不可能'),
        p('available', 'kěyòng', '可用'),
        p('free', 'miǎnfèi / kòngxián', '免费'),
        p('busy', 'máng', '忙'),
        p('ready', 'zhǔnbèi hǎo', '准备好'),
        p('correct', 'zhèngquè', '正确'),
      ]),
      group('opinion', 'Opinion', [
        p('interesting', 'yǒu yìsi', '有意思'),
        p('boring', 'wúliáo', '无聊'),
        p('amazing', 'jīngcǎi', '精彩'),
        p('terrible', 'zāogāo', '糟糕'),
        p('perfect', 'wánměi', '完美'),
        p('wrong', 'cuò', '错'),
        p('real', 'zhēn de', '真的'),
        p('true', 'zhēn', '真'),
        p('false', 'jiǎ', '假'),
        p('common', 'chángjiàn', '常见'),
      ]),
      group('misc-adj', 'Misc', [
        p('local', 'běndì', '本地'),
        p('international', 'guójì', '国际'),
        p('public', 'gōnggòng', '公共'),
        p('private', 'sīrén', '私人'),
        p('personal', 'gèrén', '个人'),
        p('social', 'shèhuì', '社会'),
        p('basic', 'jīběn', '基本'),
        p('general', 'yìbān', '一般'),
        p('special', 'tèbié', '特别'),
        p('different', 'bùtóng', '不同'),
      ]),
    ],
  },
];
